class SizeGuideModal extends HTMLElement {
  constructor() {
    super();
    this.tabs = this.querySelectorAll('.weight-tab');
    this.tabContainer = this.querySelector('.weight-tabs');
    this.table = this.querySelector('.weight-table');
    this.tabs.forEach(currentTab => {
      currentTab.addEventListener('click', this.onTabClick.bind(this));
    });
  }

  onTabClick(e) {
    const tab = e.target;
    const unit = tab.dataset.unit;
    const lbsCells = this.table.querySelectorAll('.weight-lbs');
    const kgsCells = this.table.querySelectorAll('.weight-kgs');
    const activeTab = this.tabContainer.querySelector('.active');

    if (unit === "lbs"){
      lbsCells.forEach(c => c.classList.remove('d-none'));
      kgsCells.forEach(c => c.classList.add('d-none'));
    }

    if (unit === "kgs"){
      lbsCells.forEach(c => c.classList.add('d-none'));
      kgsCells.forEach(c => c.classList.remove('d-none'));
    }

    activeTab.classList.remove('active')
    tab.classList.add('active')
  }
}

customElements.define('size-guide-modal', SizeGuideModal);
